<template>
  <div class="flex flex-col mb-4 font-display">
    <label
      :for="name"
      class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
      >{{ label }}</label
    >
    <div class="relative">
      <div
        class="absolute flex border border-transparent left-0 top-0 h-full w-12"
      >
        <div
          class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-lg h-full w-full text-gray-600"
        >
          <box-icon
            :name="icon.name"
            :type="icon.type"
            class="fill-current focus-within:text-indigo-300"
          ></box-icon>
        </div>
      </div>
      <input
        :id="id"
        :name="name"
        :type="type"
        :placeholder="label"
        :value="value"
        @focus="focusValue($event.target.value)"
        v-on:input="updateValue($event.target.value)"
        @change="$emit('change', $event.target.value)"
        class="transition duration-200 ease-in transform text-sm sm:text-base relative w-full border rounded placeholder-gray-400 focus:shadow-focus focus:border-indigo-400 focus:outline-none py-4 pr-4 pl-16"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputIcon',
  props: {
    name: String,
    type: String,
    label: String,
    icon: {
      type: Object,
      default: function () {
        return {
          name: 'user',
          type: 'regular'
        }
      }
    },
    value: {
      type: [String, Number]
    },
    id: String
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    },
    focusValue: function (value) {
      this.$emit('focus', value)
    }
  }
}
</script>

<style>
</style>
